module.exports = __webpack_public_path__ + "static_pc/img/cos04.595a2662.png";